import { useLayoutEffect, useState } from 'react';

// The line-clamp twin of useIsTextTruncated. Pass null while unclamped to keep the last answer.
export function useIsTextClamped(element: HTMLElement | null, text: string): boolean {
    const [isClamped, setIsClamped] = useState(false);

    useLayoutEffect(() => {
        if (!element) {
            return undefined;
        }
        const measure = () => {
            if (element.isConnected && element.clientHeight > 0) {
                setIsClamped(element.scrollHeight - element.clientHeight > 1);
            }
        };
        measure();
        const observer = new ResizeObserver(measure);
        observer.observe(element);
        return () => observer.disconnect();
    }, [element, text]);

    return isClamped;
}
